export default {
  meta: {
    title: '流程详情'
  }
};
